module.exports = __webpack_public_path__ + "img/circle - 複製.35be05b9.png";